export default __webpack_public_path__ + "static/media/twitter_icon.4c730c69.svg";